import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export default function ListPreview({ field, onUpdate, palette, theme }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        <Chip size="small" label="Item 1" sx={{ fontSize: '11px' }} disabled />
        <Chip size="small" label="Item 2" sx={{ fontSize: '11px' }} disabled />
      </Box>
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '3px',
          cursor: 'default',
          color: palette.textSecondary,
          alignSelf: 'flex-start',
        }}
      >
        <AddIcon sx={{ width: 13, height: 13 }} />
        <Typography sx={{ fontSize: '11px', fontWeight: 500 }}>Add item</Typography>
      </Box>
    </Box>
  );
}
